"use client";

import { clsx } from "@trydig/ui";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { useClearRefinements, useInfiniteHits } from "react-instantsearch";
import { Close } from "~/components/icons/16/Close";
import { Modal } from "~/components/ui/Modal";
import { AlgoliaFacetFilters, AlgoliaSearchbar } from "~/features/algolia/components";
import { useFilterModal } from "~/features/products/ProductListingPage/components/FilterModal/useFilterModal";
import styles from "./FilterModal.module.css";

export const FilterModal = () => {
	const { results } = useInfiniteHits();
	const totalHits = results?.nbHits ?? 0;
	const { closeModal: close, isOpen } = useFilterModal();
	const { refine: clearAllRefinements } = useClearRefinements();

	const path = usePathname().substring(1);

	const wrapperRef = useRef<HTMLDivElement>(null);

	const [filterBarOffset, setFilterBarOffset] = useState("24px");

	const filterSize = () => {
		const offsetHeight = wrapperRef.current?.offsetHeight;
		if (offsetHeight && offsetHeight < window.innerHeight) {
			setFilterBarOffset("3rem");
		} else {
			setFilterBarOffset(`calc(100vh - ${offsetHeight}px)`);
		}
	};

	useEffect(() => {
		if (wrapperRef.current) {
			new ResizeObserver(filterSize).observe(wrapperRef.current);
		}
	}, [filterSize]);

	// const Filters = useCallback(() => , [filterData]);

	return (
		<Modal modalName={path}>
			<nav
				aria-hidden={!isOpen}
				className={clsx(styles.portal, isOpen && styles.active)}
				data-active={isOpen}
			>
				<div className={styles["flex-wrapper"]} ref={wrapperRef} style={{ top: filterBarOffset }}>
					<div className={styles["mobile-header"]}>
						<span>Filter</span>
						<button type="button" onClick={close}>
							<Close />
						</button>
					</div>
					<div className={styles["search-bar__wrapper"]}>
						<AlgoliaSearchbar onSubmit={() => {}} isModalOpen={isOpen} />
					</div>

					<div className={clsx(styles["modal-sections-wrapper"], isOpen && styles.active)}>
						<AlgoliaFacetFilters />
						<div className={styles["mobile__modal-buttons"]}>
							<button
								onClick={clearAllRefinements}
								type="button"
								className="outlined"
								disabled={totalHits === 0}
							>
								Nullstill
							</button>
							<button onClick={close} type="button" className="">{`Vise (${totalHits})`}</button>
						</div>
					</div>
				</div>
			</nav>
		</Modal>
	);
};
